import http, { expandURI } from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { CLAIMS_LISTING_INIT_LOADING, CLAIMS_LISTING_INIT_SUCCESS, CLAIMS_LISTING_INIT_FAIL, CLAIMS_CLAIMDETAIL_RESET, CLAIMS_CLAIMDETAIL_LOAD_DATA } from '@/store/types'

export const list = {
  async claimListInit({ commit, state }) {
    // reset claim state (prevent dirty data)
    commit(CLAIMS_CLAIMDETAIL_RESET)

    if (state.listing.init !== 1) {
      const apiUrl = state.menu.listing
      if (apiUrl) {
        commit(CLAIMS_LISTING_INIT_LOADING)
        try {
          const result = await http.get(apiUrl)
          const menu = extractMenu(result.data._links)
          const commitResult = {
            menu: menu
          }
          commit(CLAIMS_LISTING_INIT_SUCCESS, commitResult)
        } catch (error) {
          commit(CLAIMS_LISTING_INIT_FAIL, extractMessages(error))
        }
      } else {
        commit(CLAIMS_LISTING_INIT_FAIL, ['Invalid API URL'])
      }
    }
  },
  async loadClaim({ commit, state, rootState }, data) {
    if (rootState.app.menu.getClaim && data.clmRefNo) {
      try {
        const expand = {
          clmRefNo: data.clmRefNo
        }
        const result = await http.get(expandURI(rootState.app.menu.getClaim, expand))
        if (result.data) {
          const menu = extractMenu(result.data._links)
          // data.query: to defined if its coming from query (some stuff for query are not defaulted)
          const commitResult = {
            partialSave: false,
            data: result.data,
            query: data.query,
            menu
          }
          commit(CLAIMS_CLAIMDETAIL_LOAD_DATA, commitResult)
        } else {
          throw new Error('Invalid Fetch Result')
        }
      } catch (err) {
        throw err
      }
    } else {
      throw new Error('Invalid API URL')
    }
  }
}
